import * as React from "react";
import { observer, inject } from "mobx-react";

import { CustomerStore } from "src/stores/CustomerStore";
import StatementComponent from "./StatementsComponent";
import InvoicesComponent from "./InvoicesComponent";
import SettlementsComponent from "./SettlementsComponent";
import { Customer } from "src/model/Customer";

export interface State {}

export interface Props {
    customerStore?: CustomerStore;
}

@inject("customerStore")
@observer
export default class CustomerAccount extends React.Component<Props, State> {
    render() {
        const { customerStore } = this.props;
        if (!customerStore) {
            throw new Error(" ** No Customer Store **");
        }

        const customer = customerStore.customer;
        if (!customer) {
            return null;
        }

        const account = customer.account;

        return (
            <>
                <StatementComponent />
                <InvoicesComponent />
                <SettlementsComponent />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/customer/CustomerAccount.tsx